import React from 'react';

/**
 * Reusable Edit / Delete action buttons for grid rows.
 *
 * Previously copy-pasted identically into every *Grid.js file.
 * Now a single component used by the generic DataGrid.
 */
export default function ActionButtons({
  data,
  onEdit,
  onDelete,
  editLabel = 'Edit',
  readOnly = false,
  readOnlyTitle = '',
}) {
  if (readOnly) {
    return (
      <div className="flex items-center gap-2 h-full" title={readOnlyTitle}>
        {onEdit && (
          <button
            disabled
            className="px-3 py-1 text-xs font-medium rounded bg-gray-100 text-gray-400 border border-gray-200 cursor-not-allowed"
          >
            {editLabel}
          </button>
        )}
        {onDelete && (
          <button
            disabled
            className="px-3 py-1 text-xs font-medium rounded bg-gray-100 text-gray-400 border border-gray-200 cursor-not-allowed"
          >
            Delete
          </button>
        )}
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2 h-full">
      {onEdit && (
        <button
          onClick={() => onEdit(data)}
          className="px-3 py-1 text-xs font-medium rounded bg-sky-100 text-sky-700 border border-sky-200 cursor-pointer hover:bg-sky-200 transition-colors"
        >
          {editLabel}
        </button>
      )}
      {onDelete && (
        <button
          onClick={() => onDelete(data)}
          className="px-3 py-1 text-xs font-medium rounded bg-red-100 text-red-700 border border-red-200 cursor-pointer hover:bg-red-200 transition-colors"
        >
          Delete
        </button>
      )}
    </div>
  );
}
